import Vue from 'vue'
import Vuex from 'vuex'
import page from './modules/page'
import category from './modules/category'
import auth from './modules/auth'

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        page,
        category,
        auth
    },
    strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js